module.exports = __webpack_public_path__ + "img/arrow-left.d341060a.svg";